import { Bound } from "lib/@components/binding/Bound"
import { useState } from "react"
import { DifferenceWrapper } from "routes/schedule/compare/differenceWrapper"
import { Box, Stack, useTheme } from "@mui/material"
import { DifferenceTitle } from "routes/schedule/compare/difference-title"
import { ListItemBox } from "lib/@components/ListItemBox"
import { Status } from "routes/schedule/compare/status"
import { SkillSet } from "routes/schedule/tasks/skill-set"
import { registerTaskComparitor } from "routes/schedule/compare/register-task-comparitor"
import { TargetEditor } from "routes/schedule/compare/target-editor"
import { EditModeSwitch } from "routes/schedule/compare/edit-mode-switch"
import { Approved } from "routes/schedule/compare/approved"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useBoundValue } from "lib/@components/binding/use-bound-value"

registerTaskComparitor("skillSet", () => <SkillChange label="required skill" path="skillSet" />, true)

export function SkillChange({ label }) {
    const { target, to } = useBoundContext()
    const [value, setValue] = useBoundValue("skillSet")
    const [original] = useState(value)
    const [copied, setCopied] = useState(false)
    const [hover, setHover] = useState(false)
    const theme = useTheme()

    return (
        <DifferenceWrapper label={`${target.title}: ${label}`}>
            <Stack spacing={1} sx={{ width: "100%", ml: -1 }}>
                <DifferenceTitle label={label} />
                <ListItemBox alignItems="center">
                    <Box
                        flex={1}
                        sx={{ opacity: hover ? 0.25 : 1, transition: "opacity 0.2s linear" }}
                        data-cy="skill-change-left"
                    >
                        <TargetEditor>
                            <EditModeSwitch>
                                <Bound task={target}>
                                    <SkillSet />
                                </Bound>
                            </EditModeSwitch>
                        </TargetEditor>
                    </Box>
                    <Approved width={16}>
                        <Status
                            onHover={setHover}
                            onCopyChanged={setCopied}
                            copy={copy}
                            path="skillSet"
                            revert={revert}
                        />
                        <Box
                            flex={1}
                            sx={{
                                opacity: copied ? 0.5 : 1,
                                borderRadius: 1,
                                transition: "background-color linear 0.2s",
                                bgcolor: hover ? `${theme.palette.primary.main}20` : undefined,
                            }}
                            data-cy="skill-change-right"
                        >
                            <Bound target={to} task={to} editMode={false}>
                                <SkillSet />
                            </Bound>
                        </Box>
                    </Approved>
                </ListItemBox>
            </Stack>
        </DifferenceWrapper>
    )

    function copy() {
        setValue(to.skillSet)
    }

    function revert() {
        setValue(original)
    }
}
